import { t } from '../../common/helpers/translation';

export class PasswordValidation {
  static validateNewPassword(newPassword: string): string {
    if (!newPassword) {
      return t('password-is-required');
    }
    const minLengthRegex = /.{8,}/;
    const uppercaseRegex = /[A-Z]/;
    const lowercaseRegex = /[a-z]/;
    const numberRegex = /\d/;
    return minLengthRegex.test(newPassword) &&
      uppercaseRegex.test(newPassword) &&
      lowercaseRegex.test(newPassword) &&
      numberRegex.test(newPassword)
      ? ''
      : t('password_help_message');
  }
}
